export const isConnect =
  window.location.hostname === 'meraki.connectasistencia.com' ||
  window.location.hostname === 'meraki-stg.connectasistencia.com' ||
  window.location.hostname === 'localhost';
